import { render, staticRenderFns } from "./AssistenteDesk.vue?vue&type=template&id=44994309"
import script from "./AssistenteDesk.vue?vue&type=script&lang=js"
export * from "./AssistenteDesk.vue?vue&type=script&lang=js"
import style0 from "./AssistenteDesk.vue?vue&type=style&index=0&id=44994309&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports